module.exports = __webpack_public_path__ + "img/weilonglatiao.64f936f3.jpg";